export const tenantDomains = ['tenant', 'partner', 'organisation']

export const EXPANDED_PERMISSION_AREAS_STORAGE_KEY =
  'permissions_expanded_areas'

export const UNGROUPED_PERMISSION_AREA = 'Other'
